export enum A11yRole {
  Button = 'button',
  Checkbox = 'checkbox',
  Dialog = 'dialog',
  Grid = 'grid',
  Gridcell = 'gridcell',
  Link = 'link',
  Listbox = 'listbox',
  Menu = 'menu',
  MenuItem = 'menuitem',
  MenuItemCheckbox = 'menuitemcheckbox',
  MenuItemRadio = 'menuitemradio',
  Option = 'option',
  Progressbar = 'progressbar',
  Radio = 'radio',
  Radiogroup = 'radiogroup',
  Slider = 'slider',
  Spinbutton = 'spinbutton',
  Switch = 'switch',
  Tab = 'tab',
  Tablist = 'tablist',
  Tabpanel = 'tabpanel',
  Textbox = 'textbox',
  Toolbar = 'toolbar',
  Image = 'img',
  Combobox = 'combobox',
  Status = 'status',
  Tooltip = 'tooltip',
  Accordion = 'accordion',
  Group = 'group',
  Tree = 'tree',
  Treeitem = 'treeitem',
  Region = 'region',
  Separator = 'separator',
  Alert = 'alert',
  Navigation = 'navigation',
  List = 'list',
  ListItem = 'listitem',
  Note = 'note',
  Timer = 'timer',
  Presentation = 'presentation',
  Application = 'application',
  Rowgroup = 'rowgroup',
  Row = 'row',
  Columnheader = 'columnheader',
  Table = 'table',
  Cell = 'cell',
  Text = 'text',
  None = 'none',
}